var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5529 2.39844C14.935 2.39844 16.8661 4.32956 16.8661 6.71171V9.38654H19.0178C19.781 9.38654 20.3997 10.0052 20.3997 10.7684V20.224C20.3997 20.9872 19.781 21.6058 19.0178 21.6058H4.98241C4.21925 21.6058 3.60059 20.9872 3.60059 20.224V10.7684C3.60059 10.0052 4.21925 9.38654 4.98241 9.38654H7.13412V6.71171C7.13412 4.32956 9.06524 2.39844 11.4474 2.39844H12.5529ZM12.0001 3.89871C10.3218 3.89871 8.95801 5.24567 8.93089 6.91759L8.93049 6.96834V9.38654H15.0698V6.96834C15.0698 5.27303 13.6954 3.89871 12.0001 3.89871Z",
    fill: "url(#paint0_linear_1584_67814)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2993 13.9377C11.2993 13.5828 11.6351 13.2952 12.0493 13.2952C12.4635 13.2952 12.7993 13.5828 12.7993 13.9377V16.6526C12.7993 17.0075 12.4635 17.2952 12.0493 17.2952C11.6351 17.2952 11.2993 17.0075 11.2993 16.6526V13.9377Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1584_67814",
    x1: 12.0001,
    y1: 2.39844,
    x2: 12.0001,
    y2: 21.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8919E1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.36159b9c3f8e3e103ba5a37f7584c65c.svg";
export { ForwardRef as ReactComponent };